import { FETCH_FRIENDS_INFO_SUCCESS } from "../actions/types";
import { database } from "../../App";
import { Dispatch } from "react";
import { friendActionInterface } from "../reducers/FriendsReducers";

export function fetchFromFirebase(
  currentUser: firebase.User | null,
  dispatch: Dispatch<friendActionInterface>
) {
  if (currentUser) {
    database
      .ref("users")
      .child(currentUser.uid)
      .child("friends_info")
      .on("value", snapshot => {
        return dispatch({
          type: FETCH_FRIENDS_INFO_SUCCESS,
          payload: snapshot.val()
        });
      });
  }
}
